import { createContext, PropsWithChildren, useContext } from 'react'
import { ScenarioTemplateCompact } from 'routes/Scenarios/helpers/types'

const ScenarioTemplatesContext = createContext<ScenarioTemplateCompact[]>([])
ScenarioTemplatesContext.displayName = 'ScenariosContext'

export function ScenarioTemplatesProvider({
  scenarioTemplates,
  children,
}: PropsWithChildren<{
  scenarioTemplates: ScenarioTemplateCompact[]
}>) {
  return (
    <ScenarioTemplatesContext.Provider value={scenarioTemplates}>
      {children}
    </ScenarioTemplatesContext.Provider>
  )
}

export function useScenarioTemplates() {
  return useContext(ScenarioTemplatesContext)
}
